/**
 * Checks if a time entry is billed and cannot be modified.
 * This matches the logic from EditEntry.vue's shouldShowBilledAlert.
 *
 * @param {Object} entry - The time entry object
 * @returns {boolean} - True if entry is billed and cannot be changed
 */
export default function isEntryBilled(entry) {
  if (!entry) return false;

  // Entry is in a draft invoice (Interim state)
  if (entry.billedState === 'Interim') {
    return true;
  }

  // Entry has any billed state other than WIP (Work In Progress)
  if (entry.billedState && entry.billedState !== 'WIP') {
    return true;
  }

  // Entry is manually marked as billed or system-billed
  if (entry.billed) {
    return true;
  }
  return false;
}